const roleNames: Record<number, string> = {
    2001: "User",
    1984: "Editor",
    5150: "Admin",
  };

  export const generateRoleMessage = (requiredRoles: number[], action: string, userRoles: number[]) => {
    const readableRequiredRoles = requiredRoles
      .map((role) => roleNames[role])
      .filter(Boolean); // Convert required role IDs to names
  
    const readableUserRoles = userRoles
      .map((role) => roleNames[role])
      .filter(Boolean); // Convert user's role IDs to names
  
    const roleText = readableRequiredRoles.length > 1
      ? readableRequiredRoles.join(" or ") // Example: "Admin or Editor"
      : readableRequiredRoles[0]; // Example: "Admin"
  
    const userRoleText = readableUserRoles.length
      ? readableUserRoles.join(", ") // Example: "User, Editor"
      : "no roles"; // If userRoles is empty or all null
  
    return `You need to be an ${roleText} to ${action}. You currently have the role: ${userRoleText}.`;
  };
  